module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column px-4 py-4"
  }, [_c('div', {
    staticClass: "row mx-0"
  }, [_c('Select', {
    staticClass: "col-12 px-0 mb-4",
    attrs: {
      "v": _vm.$v.workPlaceComputed.region_id,
      "label": "РЕГИОН",
      "placeholder": "Выберите регион",
      "options": _vm.regions,
      "error-text": _vm.$util.validationMessage(_vm.$v.workPlaceComputed.region_id),
      "required": "required"
    },
    model: {
      value: (_vm.workPlaceComputed.region_id),
      callback: function($$v) {
        _vm.$set(_vm.workPlaceComputed, "region_id", $$v)
      },
      expression: "workPlaceComputed.region_id"
    }
  }), _c('Checkbox', {
    staticClass: "col-12 px-0 mb-4",
    model: {
      value: (_vm.workPlaceComputed.is_inner_organizations),
      callback: function($$v) {
        _vm.$set(_vm.workPlaceComputed, "is_inner_organizations", $$v)
      },
      expression: "workPlaceComputed.is_inner_organizations"
    }
  }, [_vm._v("В организации, зарегистрированной на платформе")]), (!_vm.workPlaceComputed.is_inner_organizations) ? _c('FormInput', {
    staticClass: "col-12 px-0 mb-4",
    attrs: {
      "label": "МЕСТО РАБОТЫ",
      "placeholder": "Введите место работы",
      "v": _vm.$v.workPlaceComputed.work_place,
      "error-text": _vm.$util.validationMessage(_vm.$v.workPlaceComputed.work_place),
      "required": "required"
    },
    model: {
      value: (_vm.workPlaceComputed.work_place),
      callback: function($$v) {
        _vm.$set(_vm.workPlaceComputed, "work_place", $$v)
      },
      expression: "workPlaceComputed.work_place"
    }
  }) : _c('Select', {
    staticClass: "col-12 px-0 mb-4",
    attrs: {
      "label": "МЕСТО РАБОТЫ",
      "placeholder": "Выберите место работы",
      "options": _vm.partners,
      "v": _vm.$v.workPlaceComputed.work_place,
      "error-text": _vm.$util.validationMessage(_vm.$v.workPlaceComputed.work_place),
      "required": "required"
    },
    on: {
      "input": function($event) {
        _vm.workPlaceComputed.work_place = $event
      }
    },
    model: {
      value: (_vm.workPlaceComputed.partner_id),
      callback: function($$v) {
        _vm.$set(_vm.workPlaceComputed, "partner_id", $$v)
      },
      expression: "workPlaceComputed.partner_id"
    }
  }), _c('Select', {
    staticClass: "col-12 px-0 mb-4",
    attrs: {
      "label": "СФЕРА ДЕЯТЕЛЬНОСТИ ОРГАНИЗАЦИИ",
      "placeholder": "Выберите сферу деятельности",
      "options": _vm.profSpheres,
      "v": _vm.$v.workPlaceComputed.prof_sphere_id
    },
    model: {
      value: (_vm.workPlaceComputed.prof_sphere_id),
      callback: function($$v) {
        _vm.$set(_vm.workPlaceComputed, "prof_sphere_id", $$v)
      },
      expression: "workPlaceComputed.prof_sphere_id"
    }
  }), _c('FormInput', {
    staticClass: "col-12 px-0 mb-4",
    attrs: {
      "label": "САЙТ ОРГАНИЗАЦИИ",
      "maxlength": "255",
      "placeholder": "Введите адрес сайта",
      "v": _vm.$v.workPlaceComputed.site,
      "error-text": _vm.$util.validationMessage(_vm.$v.workPlaceComputed.site, "https://test.test")
    },
    model: {
      value: (_vm.workPlaceComputed.site),
      callback: function($$v) {
        _vm.$set(_vm.workPlaceComputed, "site", $$v)
      },
      expression: "workPlaceComputed.site"
    }
  }), _c('FormInput', {
    staticClass: "col-12 px-0 mb-4",
    attrs: {
      "label": "ДОЛЖНОСТЬ",
      "placeholder": "Введите название",
      "v": _vm.$v.workPlaceComputed.position,
      "error-text": _vm.$util.validationMessage(_vm.$v.workPlaceComputed.position),
      "required": "required"
    },
    model: {
      value: (_vm.workPlaceComputed.position),
      callback: function($$v) {
        _vm.$set(_vm.workPlaceComputed, "position", $$v)
      },
      expression: "workPlaceComputed.position"
    }
  }), _c('FormInput', {
    staticClass: "col-12 px-0 mb-4",
    attrs: {
      "label": "ОБЯЗАННОСТИ",
      "placeholder": "Введите обязанности"
    },
    model: {
      value: (_vm.workPlaceComputed.duties),
      callback: function($$v) {
        _vm.$set(_vm.workPlaceComputed, "duties", $$v)
      },
      expression: "workPlaceComputed.duties"
    }
  }), _c('FormInput', {
    staticClass: "col-12 px-0 mb-4",
    attrs: {
      "label": "ДАТА ПРИНЯТИЯ НА РАБОТУ",
      "placeholder": "Введите дату принятия",
      "mask": _vm.dateMask,
      "v": _vm.$v.workPlaceComputed.acceptance_date,
      "error-text": _vm.$util.validationMessage(_vm.$v.workPlaceComputed.acceptance_date, "27.10.2023"),
      "required": "required"
    },
    model: {
      value: (_vm.workPlaceComputed.acceptance_date),
      callback: function($$v) {
        _vm.$set(_vm.workPlaceComputed, "acceptance_date", $$v)
      },
      expression: "workPlaceComputed.acceptance_date"
    }
  }), _c('FormInput', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.workPlaceComputed.is_currently),
      expression: "!workPlaceComputed.is_currently"
    }],
    staticClass: "col-12 px-0 mb-4",
    attrs: {
      "label": "ДАТА УВОЛЬНЕНИЯ",
      "placeholder": "Введите дату увольнения",
      "mask": _vm.dateMask,
      "v": _vm.$v.workPlaceComputed.dismissal_date,
      "error-text": _vm.$util.validationMessage(_vm.$v.workPlaceComputed.dismissal_date, "27.10.2023"),
      "required": "required"
    },
    model: {
      value: (_vm.workPlaceComputed.dismissal_date),
      callback: function($$v) {
        _vm.$set(_vm.workPlaceComputed, "dismissal_date", $$v)
      },
      expression: "workPlaceComputed.dismissal_date"
    }
  }), _c('Checkbox', {
    staticClass: "col-12 px-0 mb-4",
    model: {
      value: (_vm.workPlaceComputed.is_currently),
      callback: function($$v) {
        _vm.$set(_vm.workPlaceComputed, "is_currently", $$v)
      },
      expression: "workPlaceComputed.is_currently"
    }
  }, [_vm._v("В настоящее время")]), (_vm.errors.length) ? _c('div', {
    staticClass: "col-12 px-0 mb-4"
  }, _vm._l((_vm.errors), function(error, index) {
    return _c('div', {
      key: index,
      staticClass: "error mb-2 ui_color__red",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(error))])
  }), 0) : _vm._e(), _c('div', {
    staticClass: "col-md-6 col-12 mb-2 px-0 pe-0 pe-md-2"
  }, [_c('Button', {
    attrs: {
      "disabled": false,
      "isLoading": false
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Сохранить")])], 1), _c('div', {
    staticClass: "col-md-6 col-12 col-6 mb-2 px-0 ps-0 ps-md-2"
  }, [_c('Button', {
    attrs: {
      "alignSelf": "end",
      "bordered": true
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Отменить")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28f54181","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/work/components/AddEditWorkPlaceBody.vue
// module id = afebf4566f56d3597027
// module chunks = 27